import angular from 'angular';

/* Component Imports */
import SyncRunHoursComponent from './sync-runhours-component/sync-runhours.component';
/* Config Imports */
import DevicesRouteConfig from './devices.route';
/* Controller Imports */
import DeviceActivationsBulkController from './activations/bulk/bulk.controller';
import DeviceActivationsBulkCustomController from './activations/bulk-custom/bulk-custom.controller';
import DevicesActivationsController from './activations/activations.controller';
import DevicesActivationsSingleModalController from './activations/single/templates-modal/templates.modal.controller';
import DevicesActivationsWizardController from './activations/single/single.controller';
import DevicesBaseController from './devices.base.controller';
import DevicesController from './devices.controller';
import DevicesDeactivateModalController from './view/deactivate-modal/deactivate.modal.controller';
import DevicesDeactivateModalModalController from './view/deactivate-modal/deactivate.modal.modal.controller';
import DeviceDetailController from './view/view.controller';
import DevicesListController from './list/list.controller';
import InstallationNotesModalController from './view/install-notes-modal/notes.modal.controller';
/* Directive Imports */
import TelematicsSerialNumberDirective from './devices.directive';
/* Service Imports */
import ActivationsService from './activations/activations.service';
import ActivationsRepo from './activations/activations.repo';
import SyncRunHoursService from './sync-runhours.service';

const devicesModule = angular
  .module('app.devices', ['ui.bootstrap', 'ui.router', 'gettext'])
  /* Components */
  .component('syncRunHours', SyncRunHoursComponent)
  /* Config */
  .config(DevicesRouteConfig)
  /* Controllers */
  .controller('DeviceActivationsBulkController', DeviceActivationsBulkController)
  .controller('DeviceActivationsBulkCustomController', DeviceActivationsBulkCustomController)
  .controller('DevicesActivationsController', DevicesActivationsController)
  .controller('DevicesActivationsSingleModalController', DevicesActivationsSingleModalController)
  .controller('DevicesActivationsWizardController', DevicesActivationsWizardController)
  .controller('DevicesBaseController', DevicesBaseController)
  .controller('DevicesController', DevicesController)
  .controller('DevicesDeactivateModalController', DevicesDeactivateModalController)
  .controller('DevicesDeactivateModalModalController', DevicesDeactivateModalModalController)
  .controller('DevicesDetailController', DeviceDetailController)
  .controller('DevicesListController', DevicesListController)
  .controller('InstallationNotesModalController', InstallationNotesModalController)
  /* Directives */
  .directive('telematicsserialnumber', TelematicsSerialNumberDirective)
  /* Services */
  .service('activationsService', ActivationsService)
  .service('activationsRepo', ActivationsRepo)
  .service('syncRunHoursService', SyncRunHoursService);

export default devicesModule.name;
